import { Component } from '@angular/core';

@Component({
    selector: 'app-access-denied',
    standalone: true,
    imports: [],
    templateUrl: './access-denied.component.html',
    styleUrl: './access-denied.component.scss',
})
export class AccessDeniedComponent {}
